import { Controller } from "@hotwired/stimulus"
import { inputSubmitWith } from "lib/utilities";
import { useDocumentListener } from "lib/event_helpers"

const AUTOSCROLL_DELAY = 1000;

const AUTOSCROLL_INTERVAL = 75;
const AUTOSCROLL_DISTANCE = 1;

export default class extends Controller {
  static targets = ["suggestions"];

  autoscrollTimeout = null;
  autoscrollingFrom = 0;
  autoscrollingTo = 0;

  pixelRatio = 1;

  connect() {
    this.pixelRatio = window.devicePixelRatio || 1;

    this.listenForNewMessages();
    this.listenForFormInputChanges();

    this.autoscrollTimeout = setTimeout(() => {
      this.scheduleAutoscroll();
    }, AUTOSCROLL_DELAY);
  }
  // Event Listeners

  listenForNewMessages() {
    useDocumentListener(this, 'chat--message:new', this.hide);
  }

  listenForFormInputChanges() {
    useDocumentListener(this, 'chat--form:input', this.checkInput);
  }

  // Suggestion Handling

  selectSuggestion(event) {
    const { target } = event;
    const { dataset } = target;
    const { suggestion } = dataset;

    // Select this bubble
    this.clearSelection();
    target.classList.add("selected");

    // Handle scrolling
    this.cancelAutoscroll();
    this.centerElementInView(target);

    // Form input
    inputSubmitWith("user-input", suggestion);
  }

  getSelectedSuggestion() {
    return this.suggestionsTarget.querySelector('.selected')
  }

  clearSelection() {
    this.getSelectedSuggestion()?.classList.remove('selected');
  }

  centerElementInView(element) {
    const { suggestionsTarget } = this;
    const displayWidth = suggestionsTarget.offsetWidth;

    const { offsetLeft, offsetWidth } = element;

    suggestionsTarget.scrollLeft = offsetLeft - (displayWidth - offsetWidth) / 2;
  }

  checkInput(event) {
    const inputValue = event.target.value;
    const selectedSuggestion = this.getSelectedSuggestion()?.dataset.suggestion;

    if (inputValue !== selectedSuggestion)
      this.clearSelection();
  }

  // Auto-scroll Behavior

  scheduleAutoscroll() {
    this.autoscrollTimeout = setTimeout(this.autoscroll.bind(this), AUTOSCROLL_INTERVAL);
  }

  autoscroll() {
    const { suggestionsTarget, pixelRatio } = this;
    const { scrollLeft, scrollWidth, offsetWidth } = suggestionsTarget;

    if (scrollLeft < (scrollWidth - offsetWidth)) {
      this.autoscrollingFrom = scrollLeft;
      this.autoscrollingTo = scrollLeft + (AUTOSCROLL_DISTANCE * (pixelRatio ** 2));
      suggestionsTarget.scrollLeft = this.autoscrollingTo;
      this.scheduleAutoscroll();
    }
  }

  cancelAutoscroll() {
    clearTimeout(this.autoscrollTimeout);
    this.autoscrollTimeout = null;
  }

  handleScroll() {
    const { autoscrollingFrom, autoscrollingTo, suggestionsTarget } = this;
    const { scrollLeft } = suggestionsTarget;

    const min = Math.min(autoscrollingFrom, autoscrollingTo);
    const max = Math.max(autoscrollingFrom, autoscrollingTo);

    if (scrollLeft < min || scrollLeft > max)
      this.cancelAutoscroll();
  }

  // Collapsing

  hide() {
    this.element.remove();
  }
}